/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleArrowUpRight = createReactComponent(
  "circle-arrow-up-right",
  "IconCircleArrowUpRight",
  [
    ["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", key: "svg-0" }],
    ["path", { d: "M15 9l-6 6", key: "svg-1" }],
    ["path", { d: "M15 15v-6h-6", key: "svg-2" }]
  ]
);

export { IconCircleArrowUpRight as default };
//# sourceMappingURL=IconCircleArrowUpRight.js.map
